export default "__VITE_ASSET__B4yfSo8R__"